{
	"id": 7501,
	"moduleNumber": 1,
	"title": "Professional Ethics for Educators",
	"subtitle": "Learn the ethical framework, PROETHICS principles, and how to apply them.",
	"kgNodeId": "module-1",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"summary": "Module 1 introduces professional ethics for educators, the ethical framework used throughout ProEthica, and the ProEthics principles learners will apply in later scenario-based modules.",
	"estimatedDurationMinutes": 25,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": false,
		"questionCount": 0
	}
}
